import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslatePipe],
  template: `
    <h2 mat-dialog-title>{{ 'auth.sessionExpired.title' | translate }}</h2>
    <mat-dialog-content>{{ 'auth.sessionExpired.message' | translate }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">{{ 'auth.sessionExpired.logout' | translate }}</button>
      <button mat-flat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'auth.sessionExpired.stayConnected' | translate }}</button>
    </mat-dialog-actions>
  `
})
export class SessionExpiredDialogComponent {}
